import React from "react";
import { motion } from "framer-motion";
import Axis from "../assests/Images/Bank/AXISBank.png";
import BOB from "../assests/Images/Bank/BOB.png";
import BOI from "../assests/Images/Bank/BOI.png";
import BOM from "../assests/Images/Bank/BOM.png";
import BandhanBank from "../assests/Images/Bank/BandhanBank.png";
import CBI from "../assests/Images/Bank/CBI.png";
import Canbank from "../assests/Images/Bank/Canbank.png";
import FederalBank from "../assests/Images/Bank/FederalBank.png";
import HDFC from "../assests/Images/Bank/HDFCBank.png";
import ICICI from "../assests/Images/Bank/ICICIBank.png";
import IDBI from "../assests/Images/Bank/IDBI.png";
import Indusland from "../assests/Images/Bank/IndusIndBank.png";
import Kotak from "../assests/Images/Bank/KotakMBank.png";
import PNB from "../assests/Images/Bank/PNB.png";
import RBL from "../assests/Images/Bank/RBLBank.png";
import SBI from "../assests/Images/Bank/SBI.png";
import Union from "../assests/Images/Bank/UnionBank.png";
import Yes from "../assests/Images/Bank/YesBank.png";

const partnersData = [
  { img: Axis, name: "axis" },
  { img: BOB, name: "BOB" },
  { img: BOI, name: "BOI" },
  { img: BOM, name: "BOM" },
  { img: BandhanBank, name: "BandhanBank" },
  { img: CBI, name: "CBI" },
  { img: Canbank, name: "Canbank" },
  { img: FederalBank, name: "FederalBank" },
  { img: HDFC, name: "HDFC" },
  { img: ICICI, name: "ICICI" },
  { img: Indusland, name: "Indusland" },
  { img: Kotak, name: "Kotak" },
  { img: PNB, name: "PNB" },
  { img: RBL, name: "RBL" },
  { img: SBI, name: "SBI" },
  { img: Union, name: "Union" },
  { img: Yes, name: "Yes" },
];

const PartnersLogo = (props) => {
  return (
    <div className="flex justify-center transform transition" key={props.name}>
      <img src={props.img} alt={props.name} className="object-contain px-5" />
    </div>
  );
};

const PartnerWithUs = () => {
  return (
    <section className="relative  py-16 overflow-hidden block">
      <div className="relative max-w-7xl mx-auto px-4 text-center">
        {/* Section Heading */}
        <h2 className="text-4xl font-bold text-gray-800 mb-12">
          Our Trusted Partners
        </h2>

        <div className="flex flex-1 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_20%,black_80%,transparent)]">
          <motion.div
            initial={{ translateX: "-50%" }}
            animate={{ translateX: "0%" }}
            transition={{
              repeat: Infinity,
              duration: 30,
              ease: "linear",
            }}
            className="flex flex-none gap-14 pr-14 -translate-x-0"
          >
            {partnersData.map((partner) => (
              <img
                src={partner.img}
                key={partner.index}
                className="h-6 w-auto flex-none"
              />
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnerWithUs;
